import {Card, Timeline, Typography} from 'antd';
import moment from 'moment';
import {formatEnumLabel, resolveActorName} from '../kybUtils';
import styles from '../kybDashboard.module.scss';

const {Text} = Typography;

/**
 * The reviewer trail.
 *
 * `statusHistory.actorId` is a raw id with no `actor` field to expand, so the
 * only name available is the reviewer stamped on the account. Anything else
 * renders as the transition alone — an ObjectId on screen tells a reader
 * nothing and reads like a bug.
 */
export const KybStatusHistory = ({account}) => {
  const history = account?.statusHistory || [];

  return (
    <Card title="Verification history" className={styles.card}>
      {!history.length ? (
        <Text type="secondary">Nothing has moved yet.</Text>
      ) : (
        <Timeline>
          {history.map((entry, index) => {
            const actor = resolveActorName(entry.actorId, account);
            return (
              <Timeline.Item key={`${entry.at}-${index}`} color="#8d6cfa">
                <div className={styles.entityCell}>
                  <span>
                    {formatEnumLabel(entry.from)} → {formatEnumLabel(entry.to)}
                    {actor ? ` · ${actor}` : ''}
                  </span>
                  <span className={styles.subtle}>
                    {entry.at
                      ? moment(entry.at).format('DD MMM YYYY, HH:mm')
                      : '—'}
                  </span>
                  {entry.reason && <Text type="secondary">{entry.reason}</Text>}
                </div>
              </Timeline.Item>
            );
          })}
        </Timeline>
      )}
    </Card>
  );
};
